import { configureStore, type Action, type ThunkAction } from '@reduxjs/toolkit';
import authReducer from './auth.slice.ts';
import uiReducer from './ui.slice.ts';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<R = void> = ThunkAction<R, RootState, unknown, Action>;
